export const PACKAGES = [
  { id: "duchess", label: "The Duchess", price: 225, link: "https://square.link/u/qJ57y5u2" },
  { id: "countess", label: "The Countess", price: 325, link: "https://square.link/u/gCuhSGtO" },
  { id: "princess", label: "The Princess", price: 425, link: "https://square.link/u/G68wenAK" },
  { id: "marquess", label: "The Marquess", price: 525, link: "https://square.link/u/Crn7ALes" },
  { id: "empress", label: "The Empress", price: 625, link: "https://square.link/u/ANSuzou7" },
  { id: "queen", label: "The Queen", price: 725, link: "https://square.link/u/fZdIjBwk" },
];

// Eggs and scoops are billed separately — they have their own simplified order modals.
export const EGG_OPTIONS = [
  { id: "egg-1", label: "One Golden Egg",    price: 150, qty: 1, reveals: "1 Mystery Purse",   link: "https://square.link/u/jUUvz3Rm" },
  { id: "egg-2", label: "Two Golden Eggs",   price: 300, qty: 2, reveals: "2 Mystery Purses",  link: "https://square.link/u/VAHu2Say" },
  { id: "egg-3", label: "Three Golden Eggs", price: 450, qty: 3, reveals: "3 Mystery Purses",  link: "https://square.link/u/BFJSGMDh" },
  { id: "egg-4", label: "Four Golden Eggs",  price: 600, qty: 4, reveals: "4 Mystery Purses",  link: "https://square.link/u/IhWUU8IS" },
];

export const SCOOP_OPTIONS = [
  { id: "scoop-1", label: "One Scoop of Pearls",   price: 100, qty: 1, reveals: "1 Scoop of Magical Pearls",  link: "https://square.link/u/JSuLmkXw" },
  { id: "scoop-2", label: "Two Scoops of Pearls",  price: 200, qty: 2, reveals: "2 Scoops of Magical Pearls", link: "https://square.link/u/E2xhfQOx" },
];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA",
  "KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT",
  "VA","WA","WV","WI","WY","DC",
];

export const COUNTRIES = [
  "United States", "Canada", "United Kingdom", "Australia", "Germany",
  "France", "Japan", "Mexico", "Brazil", "Other",
];

export const PURSE_TYPES = [
  "Crossbody", "Tote", "Clutch", "Shoulder Bag", "Mini Bag",
  "Backpack", "Satchel", "Hobo Bag", "Surprise Me!",
];

export const DESIGNERS = [
  "Louis Vuitton", "Gucci", "Chanel", "Dior", "YSL",
  "Hermes", "Prada", "Fendi", "Balenciaga", "Surprise Me!",
];

export const EMPTY_FORM = {
  customer_name: "", email: "", phone: "",
  billing_address: "", billing_city: "", billing_state: "", billing_zip: "", billing_country: "United States",
  shipping_same_as_billing: true,
  shipping_address: "", shipping_city: "", shipping_state: "", shipping_zip: "", shipping_country: "United States",
  package_id: "",
  favorite_color: "", purse_type: "", favorite_designer: "",
  jewelry_metal: "", jewelry_style: "", notes: "",
};

export const INPUT_CLASS =
  "bg-black/50 border-[#D4AF37]/30 focus:border-[#D4AF37] text-white placeholder:text-white/30 font-montserrat h-12";
export const LABEL_CLASS =
  "text-[#D4AF37]/80 text-xs tracking-[0.2em] uppercase font-montserrat mb-2";
